import { useEffect } from "react";
import { eventBus } from "../../Common/EventBus";
import { toast, Toaster } from "sonner";
import "./styles.css";

export const Notifications = () => {
  useEffect(() => {
    const fn = (data: any) => {
      console.log(data);
      const isError = data instanceof Error;
      if (isError) {
        return toast.error(data.message);
      }
      const isNotification = data instanceof Notification;
      if (isNotification) {
        const notification = data as Notification;

        switch (notification.getType()) {
          case "error":
            toast.error(notification.getMessage());
            break;
          case "success":
            toast.success(notification.getMessage());
            break;
          case "info":
            toast.info(notification.getMessage());
            break;
        }
      }
    };

    eventBus.on("NOTIFICATION", fn);

    return () => {
      eventBus.off("NOTIFICATION", fn);
    };
  }, []);

  return <Toaster position="top-right" closeButton />;
};

export class Notification {
  private type: "error" | "success" | "info" | "blank";
  private message: string;

  constructor(type: "error" | "success" | "info" | "blank", message: string) {
    this.type = type;
    this.message = message;
  }

  public getType() {
    return this.type;
  }

  public getMessage() {
    return this.message;
  }

  static buildNotification(
    type: "error" | "success" | "info" | "blank",
    message: string
  ) {
    return new Notification(type, message);
  }
}
